import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { LpdNano1 } from './pages/LpdNano1';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/lpd-nano-1" element={<LpdNano1 data-id="element-5" />} data-id="element-4" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}